import { message } from "ant-design-vue";
import Clipboard from "clipboard";

const ua = navigator.userAgent.toLowerCase().indexOf("chikii") > -1;
const url = window.location.href.indexOf("chikiigame.com") > -1;
const isChikii = ua || url;
function clipboardSuccess() {
  message.success(isChikii ? "copy success" : "复制成功");
}

function clipboardError() {
  message.error(isChikii ? "copy fail" : "复制失败");
}
export function handleClipboard(text: string, event: HTMLAnchorElement) {
  console.log(text, event, "handleClipboard");

  const clipboard = new Clipboard(event.target, {
    text: () => text,
  });
  clipboard.on("success", () => {
    clipboardSuccess();
    clipboard.destroy();
  });
  clipboard.on("error", () => {
    clipboardError();
    clipboard.destroy();
  });
  clipboard.onClick(event);
}
